<template>
  <SecondaryBackground>
    <Spinner v-if="loading" class="mx-auto mt-4"/>
    <div
        v-if="!loading"
        class="mt-5 sm:mt-16 z-40 min-w-full sm:min-w-30 max-w-3xl mx-auto"
    >
      <AccountSettings
          v-if="personalDetails"
          :details="personalDetails"
          :updating="accountUpdating"
          class="mb-8"
          @submit="submitAccountSettings"
      />

      <!--      <div id="subscription" class="mb-8">-->
      <!--        <AccountLicense />-->
      <!--      </div>-->

      <!-- Credit Card -->
      <div id="creditcard" class="mb-8">
        <AccountPaymentOptions/>
      </div>

      <!-- Invoices Card -->
      <div id="invoices" class="mb-8">
        <AccountInvoices/>
      </div>
    </div>
  </SecondaryBackground>
</template>

<script>
import AccountSettings from '../components/common/account/AccountSettings'
import AccountLicense from '../components/common/account/AccountLicense'
import AccountPaymentOptions from '@/components/common/account/AccountPaymentOptions'
import AccountInvoices from '@/components/common/account/AccountInvoices'
import SecondaryBackground from '../components/common/layout/SecondaryBackground'
import { mapActions, mapGetters } from 'vuex'
import Spinner from '../components/common/Spinner'

export default {
  name      : 'Account',
  components: {
    Spinner,
    SecondaryBackground,
    AccountSettings,
    AccountLicense,
    AccountPaymentOptions,
    AccountInvoices,
  },
  data () {
    return {
      accountUpdating: false,
      loading        : false
    }
  },
  computed: {
    ...mapGetters(['personalDetails'])
  },
  async created () {
    try {
      this.loading = true
      await this.getPersonalDetails()
      this.loading = false
    } catch (e) {
      this.loading = false
    }
  },

  mounted () {
    if (this.$route.params.section) {
      const section = this.$route.params.section
      const timer = setInterval(() => {

        if (document.getElementById(section)) {
          clearInterval(timer)
          this.$scrollTo('#' + section, 600)
        }

      }, 200)
    }
  },
  methods: {
    ...mapActions([
      'getPersonalDetails',
      'updatePersonalDetails',
      'setSuccessMessage'
    ]),
    async submitAccountSettings (data) {
      const fd = new FormData()
      fd.append('first_name', data.firstName)
      fd.append('last_name', data.lastName)
      fd.append('email', data.email)
      fd.append('phone', data.phone)
      fd.append('company', data.company)
      if (data.avatar) {
        fd.append('avatar', data.avatar)
      }
      try {
        this.accountUpdating = true
        await this.updatePersonalDetails(fd)
        await this.setSuccessMessage('Account was successfully updated')
        this.accountUpdating = false
      } catch (e) {
        this.accountUpdating = false
      }
    }
  }
}
</script>
